import React from 'react';
import BigNumber from 'bignumber.js';

const FarmHarvestNftSection = ({ farmData }) => {
  const experienceEarned = () => {
    const earnedValue = new BigNumber(farmData.pendingExperience)
      .div(new BigNumber(10).pow(process.env.REACT_APP_DECIMALS));

    return earnedValue.toFormat(earnedValue.eq(0) || earnedValue.gt(1) ? 2 : 6);
  }

  const earned = () => {
    if (!farmData.hasNFT) {
      return 0.0;
    }

    const earnedValue = new BigNumber(farmData.pendingToken)
      .times(farmData.selectedNft.boostStake)
      .div(100)
      .div(new BigNumber(10).pow(process.env.REACT_APP_DECIMALS));

    return earnedValue.toFormat(earnedValue.eq(0) || earnedValue.gt(1) ? 2 : 6);
  }

  const boost = () => {
    if (!farmData.hasNFT) {
      return null;
    }

    return `(${new BigNumber(farmData.selectedNft.boostStake).toFormat(2)}%)`;
  }

  return (
    <>
      <small className="is-flex is-justify-content-space-between">
        <span className="has-text-warning">BOOST { boost() }</span>
        <span className="has-text-warning">EXPERIENCE</span>
      </small>
      <div className="level is-mobile">
        <div className="level-left">
          <div className="level-item">
            <h5 className="is-size-5 has-text-weight-semibold">
              { earned() }
            </h5>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <h5 className="is-size-5 has-text-weight-semibold">
              { experienceEarned() }
            </h5>
          </div>
        </div>
      </div>
    </>
  );
}

export default FarmHarvestNftSection;
